import { publicGet, publicPost } from '@/lib/publicFetch';
import type {
  PublicStayConfig,
  StayAvailabilityResult,
  StayBookingConfirmation,
} from './types';

// Public stay client: no auth, no axios (CX-489). Paths are under /api/v1/public/stays.
const BASE = '/stays';

export function fetchStayConfig(
  publicToken: string,
  options: { preview?: boolean } = {},
): Promise<PublicStayConfig> {
  return publicGet<PublicStayConfig>(`${BASE}/${publicToken}/config`, options.preview ? { preview: '1' } : undefined);
}

export function fetchStayAvailability(
  publicToken: string,
  params: { arrivalDate: string; departureDate: string; guests: number },
): Promise<StayAvailabilityResult> {
  return publicGet<StayAvailabilityResult>(`${BASE}/${publicToken}/availability`, params);
}

export function submitStayBooking(
  publicToken: string,
  body: Record<string, unknown>,
): Promise<StayBookingConfirmation | null> {
  return publicPost<StayBookingConfirmation | null>(`${BASE}/${publicToken}/book`, body);
}

export function fetchStayCancellation(cancellationToken: string) {
  return publicGet<{
    reference: string;
    resourceTypeName: string;
    arrivalDate: string;
    departureDate: string;
    status: string;
    cancellable: boolean;
    cancellationDeadline: string;
  }>(`${BASE}/cancel/${cancellationToken}`);
}

export async function submitStayCancellation(cancellationToken: string) {
  return publicPost<unknown>(`${BASE}/cancel/${cancellationToken}`);
}
